module.exports = __webpack_public_path__ + "img/howitworks-2-lp.f8e66b1.svg";